import React from 'react';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';
import ServiceBusiness from '../sections/ServiceBusiness';
// Business-specific sections (in-file)
import SectionTitle from '../../components/Common/SectionTitle';

import ScrollToTop from '../../components/Common/ScrollTop';
import OnepageContactPart from '../../components/Contact/OnepageContact';


// Breadcrumbs Image
import breadcrumbsImg from '../../assets/img/breadcrumbs/2.jpg';
// service icons removed — handled inside ServiceBusiness

const BusinessDevelopment = () => {
    return (
        <React.Fragment>
            <DetailsHeader parentMenu='service' secondParentMenu='services' activeMenu='/service/business-development' />
            <SiteBreadcrumb breadcrumbsImg={breadcrumbsImg} pageTitle='Business Development' pageCategory='Services' pageName='Business Development' parentPath="/service" />

            <ServiceBusiness />

            {/* Business-specific About / CTA / Process sections */}
            <BusinessAbout />
            <BusinessCTA />
            <BusinessProcess />
 
            <OnepageContactPart contactSectionClass="rs-contact gray-bg pt-120 md-pt-80" />
    
            <ScrollToTop />

            <Footer />
            <SearchModal />
        </React.Fragment>
    );
}

export default BusinessDevelopment;

function BusinessAbout() {
    return (
        <div className="rs-about style3 pt-80 pb-60">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-44"
                    subtitleClass="sub-text"
                    subtitle="Why Bizu"
                    titleClass="title testi-title"
                    title="Business Development Services Overview"
                />
                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <p><strong>Market Analysis and Research:</strong> Bizu LLC specializes in conducting comprehensive market analysis and research. We employ advanced techniques and tools to gather valuable insights, find market trends, assess competition, and find growth opportunities. Our in-depth analysis helps businesses make informed decisions and stay ahead of the curve.</p>

                        <p><strong>Business Strategy Development:</strong> We collaborate closely with our clients to develop effective business strategies that align with their goals and objectives. Our experienced consultants conduct thorough assessments of the business landscape, analyze strengths and weaknesses, and develop strategic plans that encompass market positioning, competitive differentiation, and growth strategies.</p>

                        <p><strong>Market Entry and Expansion:</strong> Bizu LLC supports organizations in entering new markets and expanding their operations. We provide comprehensive market entry strategies that include market assessments, feasibility studies, risk analysis, and strategic partnerships. Our team helps in setting up local presence, finding distribution channels, and navigating regulatory requirements for successful market entry and expansion.</p>

                        <p><strong>Strategic Partnerships and Alliances:</strong> We facilitate strategic partnerships and alliances to help businesses use synergies and accelerate growth. Through our extensive network and targeted outreach efforts, we find potential partners, negotiate agreements, and manage ongoing relationships. Our goal is to create mutually beneficial collaborations that drive innovation and enhance market presence.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function BusinessCTA() {
    return (
        <div className="rs-cta style2 pt-60 pb-60">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 text-center">
                        <h2>Ready to grow your business?</h2>
                        <p>Contact Bizu LLC to discuss a tailored business development plan, market entry strategy, or partnership opportunity.</p>
                        <div className="btn-part">
                            <a className="readon started" href="/contact">Get In Touch</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function BusinessProcess() {
    return (
        <div className="rs-process style3 gray-bg pt-80 pb-80">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-44"
                    subtitleClass="sub-text"
                    subtitle="Our Approach"
                    titleClass="title testi-title"
                    title="How We Deliver Business Development"
                />
                <div className="row">
                    <div className="col-md-6">
                        <h4>Funding & Investment Support</h4>
                        <p>Bizu LLC helps businesses secure funding and investment to fuel their growth goals. We prepare business plans, financial projections, and investor pitches and guide access to VC, private equity, and grants.</p>

                        <h4>Business Process Optimization</h4>
                        <p>We analyze workflows and recommend automation and reengineering to improve efficiency, reduce costs, and increase productivity.</p>
                    </div>
                    <div className="col-md-6">
                        <h4>Change Management & Organizational Development</h4>
                        <p>We provide change management strategies, stakeholder engagement plans, and leadership development programs to support organizational transitions.</p>

                        <h4>Training & Development</h4>
                        <p>Customized training programs — leadership, sales, customer service, and professional skills — delivered in-person or virtually.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
